import * as controllers from "./Controllers";
import * as modalControllers from "./Controllers/modal";
import autoGrowDirective from "./Directives/autoGrowDirective";
import confirmDirective from "./Directives/confirmDirective";
import convertDirective from "./Directives/convertDirective";
import shortenFilter from "./utils/shortenFilter";
import * as services from "./Services";
import modal from "./utils/modal";

const getNames = modules => Object.values(modules).map(m => m.name);

const allNames = [
  ...getNames(controllers),
  ...getNames(modalControllers),
  autoGrowDirective.name,
  confirmDirective.name,
  convertDirective.name,
  ...getNames(services),
  modal.name,
  shortenFilter.name,
];

export default allNames;
